<template>
  <div class="minerve-step-two">
    <div class="content">
      <div class="img-container">
        <img src="@/assets/img/schema_minerve.svg">
        <v-text-field
          v-model="form.body_measures.g"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) G"
          :class="{ error: errors.has('(Schéma) G') }"
          outlined
          type="number"
          style="top: 29%;left: 3%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures.i"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) I"
          :class="{ error: errors.has('(Schéma) I') }"
          outlined
          type="number"
          style="top: 48.3%;left: 3%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures.j"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) J"
          :class="{ error: errors.has('(Schéma) J') }"
          outlined
          type="number"
          style="top: 64.7%;left: 3%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures.k"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) K"
          :class="{ error: errors.has('(Schéma) K') }"
          outlined
          type="number"
          style="top: 73.4%;left: 3%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures.l"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) L"
          :class="{ error: errors.has('(Schéma) L') }"
          outlined
          type="number"
          style="top: 73.4%;left: 16.1%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[1].a1"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A1"
          :class="{ error: errors.has('(Schéma) A1') }"
          outlined
          type="number"
          style="top: 3.1%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[1].b1"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) B1"
          :class="{ error: errors.has('(Schéma) B1') }"
          outlined
          type="number"
          style="top: 3.1%;left: 56.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[1].e1"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E1"
          :class="{ error: errors.has('(Schéma) E1') }"
          outlined
          type="number"
          style="top: 3.1%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[1].f1"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F1"
          :class="{ error: errors.has('(Schéma) F1') }"
          outlined
          type="number"
          style="top: 3.1%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[2].a2"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A2"
          :class="{ error: errors.has('(Schéma) A2') }"
          outlined
          type="number"
          style="top: 10.2%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[2].b2"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) B2"
          :class="{ error: errors.has('(Schéma) B2') }"
          outlined
          type="number"
          style="top: 10.2%;left: 56.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[2].e2"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E2"
          :class="{ error: errors.has('(Schéma) E2') }"
          outlined
          type="number"
          style="top: 10.2%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[2].f2"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F2"
          :class="{ error: errors.has('(Schéma) F2') }"
          outlined
          type="number"
          style="top: 10.2%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[3].a3"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A3"
          :class="{ error: errors.has('(Schéma) A3') }"
          outlined
          type="number"
          style="top: 17.3%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[3].b3"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) B3"
          :class="{ error: errors.has('(Schéma) B3') }"
          outlined
          type="number"
          style="top: 17.3%;left: 56.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[3].e3"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E3"
          :class="{ error: errors.has('(Schéma) E3') }"
          outlined
          type="number"
          style="top: 17.3%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[3].f3"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F3"
          :class="{ error: errors.has('(Schéma) F3') }"
          outlined
          type="number"
          style="top: 17.3%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[4].a4"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A4"
          :class="{ error: errors.has('(Schéma) A4') }"
          outlined
          type="number"
          style="top: 24.5%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[4].b4"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) B4"
          :class="{ error: errors.has('(Schéma) B4') }"
          outlined
          type="number"
          style="top: 24.5%;left: 56.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[4].e4"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E4"
          :class="{ error: errors.has('(Schéma) E4') }"
          outlined
          type="number"
          style="top: 24.5%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[4].f4"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F4"
          :class="{ error: errors.has('(Schéma) F4') }"
          outlined
          type="number"
          style="top: 24.5%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[5].a5"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A5"
          :class="{ error: errors.has('(Schéma) A5') }"
          outlined
          type="number"
          style="top: 35%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[5].c5"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) C5"
          :class="{ error: errors.has('(Schéma) C5') }"
          outlined
          type="number"
          style="top: 35%;left: 53%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[5].d5"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) D5"
          :class="{ error: errors.has('(Schéma) D5') }"
          outlined
          type="number"
          style="top: 35%;left: 60.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[5].e5"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E5"
          :class="{ error: errors.has('(Schéma) E5') }"
          outlined
          type="number"
          style="top: 35%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[5].f5"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F5"
          :class="{ error: errors.has('(Schéma) F5') }"
          outlined
          type="number"
          style="top: 35%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[6].a6"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A6"
          :class="{ error: errors.has('(Schéma) A6') }"
          outlined
          type="number"
          style="top: 41.9%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[6].c6"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) C6"
          :class="{ error: errors.has('(Schéma) C6') }"
          outlined
          type="number"
          style="top: 41.9%;left: 53%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[6].d6"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) D6"
          :class="{ error: errors.has('(Schéma) D6') }"
          outlined
          type="number"
          style="top: 41.9%;left: 60.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[6].e6"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E6"
          :class="{ error: errors.has('(Schéma) E6') }"
          outlined
          type="number"
          style="top: 41.9%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[6].f6"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F6"
          :class="{ error: errors.has('(Schéma) F6') }"
          outlined
          type="number"
          style="top: 41.9%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[7].a7"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A7"
          :class="{ error: errors.has('(Schéma) A7') }"
          outlined
          type="number"
          style="top: 51.1%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[7].c7"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) C7"
          :class="{ error: errors.has('(Schéma) C7') }"
          outlined
          type="number"
          style="top: 51.1%;left: 53%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[7].d7"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) D7"
          :class="{ error: errors.has('(Schéma) D7') }"
          outlined
          type="number"
          style="top: 51.1%;left: 60.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[7].e7"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E7"
          :class="{ error: errors.has('(Schéma) E7') }"
          outlined
          type="number"
          style="top: 51.1%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[7].f7"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F7"
          :class="{ error: errors.has('(Schéma) F7') }"
          outlined
          type="number"
          style="top: 51.1%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[8].a8"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A8"
          :class="{ error: errors.has('(Schéma) A8') }"
          outlined
          type="number"
          style="top: 58.2%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[8].c8"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) C8"
          :class="{ error: errors.has('(Schéma) C8') }"
          outlined
          type="number"
          style="top: 58.2%;left: 53%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[8].d8"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) D8"
          :class="{ error: errors.has('(Schéma) D8') }"
          outlined
          type="number"
          style="top: 58.2%;left: 60.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[8].e8"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E8"
          :class="{ error: errors.has('(Schéma) E8') }"
          outlined
          type="number"
          style="top: 58.2%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[9].a9"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A9"
          :class="{ error: errors.has('(Schéma) A9') }"
          outlined
          type="number"
          style="top: 69.2%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[9].c9"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) C9"
          :class="{ error: errors.has('(Schéma) C9') }"
          outlined
          type="number"
          style="top: 69.2%;left: 53%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[9].d9"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) D9"
          :class="{ error: errors.has('(Schéma) D9') }"
          outlined
          type="number"
          style="top: 69.2%;left: 60.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[9].e9"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E9"
          :class="{ error: errors.has('(Schéma) E9') }"
          outlined
          type="number"
          style="top: 69.2%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[9].f9"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F9"
          :class="{ error: errors.has('(Schéma) F9') }"
          outlined
          type="number"
          style="top: 69.2%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[10].a10"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A10"
          :class="{ error: errors.has('(Schéma) A10') }"
          outlined
          type="number"
          style="top: 77.8%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[10].c10"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) C10"
          :class="{ error: errors.has('(Schéma) C10') }"
          outlined
          type="number"
          style="top: 77.8%;left: 53%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[10].d10"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) D10"
          :class="{ error: errors.has('(Schéma) D10') }"
          outlined
          type="number"
          style="top: 77.8%;left: 60.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[10].e10"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E10"
          :class="{ error: errors.has('(Schéma) E10') }"
          outlined
          type="number"
          style="top: 77.8%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[10].f10"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F10"
          :class="{ error: errors.has('(Schéma) F10') }"
          outlined
          type="number"
          style="top: 77.8%;left: 83.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[11].a11"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) A11"
          :class="{ error: errors.has('(Schéma) A11') }"
          outlined
          type="number"
          style="top: 87.9%;left: 42.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[11].c11"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) C11"
          :class="{ error: errors.has('(Schéma) C11') }"
          outlined
          type="number"
          style="top: 87.9%;left: 53%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[11].d11"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) D11"
          :class="{ error: errors.has('(Schéma) D11') }"
          outlined
          type="number"
          style="top: 87.9%;left: 60.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[11].e11"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) E11"
          :class="{ error: errors.has('(Schéma) E11') }"
          outlined
          type="number"
          style="top: 87.9%;left: 71.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.body_measures[11].f11"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma) F11"
          :class="{ error: errors.has('(Schéma) F11') }"
          outlined
          type="number"
          style="top: 87.9%;left: 83.5%;"
          height="100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MinerveStepTwo",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style lang="scss">
.minerve-step-two {
  .content {
    display: flex;
    min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        height: 100%;
        width: 100%;
        min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 8%;
        height: 5.4%;
        @media (max-width: 800px) {
          height: 4.4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
            fieldset {
              border: none;
            }
            input {
              text-align: center;
              margin-top: 7px;
            }
          }
        }
      }
    }
  }
}
</style>
